// extracted by mini-css-extract-plugin
export default {"navContainer":"DSGNavigation_navContainer__j5Adt","navButton":"DSGNavigation_navButton__OhlXq","invisible":"DSGNavigation_invisible__zhoky"};